<script>
import axios from 'axios';
import truncate from 'truncate';
import format from 'string-format';
import Paginate from 'vuejs-paginate-next';

export default {
    props: {
        s: String,
        labels: String,
        lang: String,
    },
    computed: {
        getResultLabel() {
            return format(this.parsedLabels.search_result_all, this.searchWord, this.totalResult);
        }
    },
    mounted() {
        const currentUrl = window.location.href;
        const urlParams = new URLSearchParams(currentUrl);
        this.axiosParams.search = urlParams.get('s');
        this.axiosParams.search = this.s;
        this.parsedLabels = JSON.parse(this.labels);
        this.axiosParams.lang = this.lang;
        this.getSearch();
        document.getElementById("search-field").focus();
    },
    data() {
        return {
            axiosUrl: '/wp-json/wp/v2/search',
            axiosParams: {
                per_page: 6,
                page: 1,
                search: '',
                _embed: 'self',
                lang: '',
            },
            previousSearch: '',
            result: [],
            pageCount: 1,
            totalResult: 0,
            searchWord: '',
            parsedLabels: { search_result_all: '', search_result: '' },
            loading: false,
            hasSearched: false,
        };
    },
    components: {
        paginate: Paginate,
    },
    watch: {
        'axiosParams.page'(newValue, oldValue) {
            if (newValue != oldValue) {
                this.getSearch();
            }
        },
    },
    methods: {
        getSearch() {
            if (this.axiosParams.search === '') {
                return;
            }

            this.loading = true;

            const params = Object.assign({}, this.axiosParams);

            axios
                .get(this.axiosUrl, { params: { search: params.search, per_page: 9999, lang: params.lang } })
                .then((response) => {
                    this.setTotalResult(response.headers);
                    this.previousSearch = this.axiosParams.search;
                })
                .catch((error) => {
                    console.log(error);
                });

            axios
                .get(this.axiosUrl, { params: params })
                .then((response) => {
                    this.updateUrlParam();
                    this.searchWord = this.axiosParams.search;
                    this.result = response.data;
                    this.configPagination(response.headers);
                    setTimeout(() => {
                        this.loading = false;
                        window.scrollTo(0, 0);
                    }, 1000);
                    this.hasSearched = true;
                })
        },
        truncateString(string, limit) {
            return truncate(string, limit);
        },
        doPagination(page) {
            this.axiosParams.page = page;
        },
        formSubmit(e) {
            e.preventDefault();
            this.resetAxiosParams();
            this.getSearch();
        },
        configPagination(headers) {
            this.pageCount = +headers['x-wp-totalpages'];
        },
        setTotalResult(headers) {
            this.totalResult = +headers['x-wp-total'];
        },
        resetAxiosParams() {
            this.axiosParams.page = 1;
        },
        updateUrlParam() {
            window.history.replaceState(null, null, `?s=${this.axiosParams.search}`);
        },
        getPosttype(item) {
            if (!item.subtype || item.subtype === 'page') {
                return;
            }
        },
    },
};
</script>

<template>
    <form class="search-form" @submit="formSubmit">
        <fieldset class="search-form__fieldset wrapper">
            <div class="search-form__input-container">
                <input class="search-form__field" id="search-field" type="search" v-model="axiosParams.search" :aria-label="parsedLabels.search_label" required />
                <button type="submit" class="search-form__button button button--search" :aria-label="parsedLabels.search_button">{{parsedLabels.search_button}}<span></span></button>
            </div>
        </fieldset>
    </form>
    <div id="search-list" class="search-result">
        <p class="search-result__result-label" v-if=hasSearched v-html="getResultLabel"></p>
        <div v-if="loading" class="search-result__loader">
            <div class="loader"></div>
        </div>
        <div class="search-result__content" v-if="!loading">
            <ul class="search-result__list">
                <li class="search-result__list-item" v-for="item in result" :key="item.id">
                    <div v-if="item.subtype == 'press_release'" class="press-item">
                        <img v-if="item._embedded.self[0].image" class="press-item__image" :src=item._embedded.self[0].image :alt="item.title">
                        <div class="press-item__content">
                            <p class="press-item__date
                                date">{{parsedLabels.pressrelease}} ·
                                {{item._embedded.self[0].custom_date}}</p>
                            <h3 class="press-item__title h3" v-html="item.title"></h3>
                        </div>
                        <a class="press-item__link"
                            :href=item.url>{{parsedLabels.read_more}}</a>
                    </div>
                    <div v-else-if="item.subtype == 'report'" class="report-item">
                        <p class="report-item__date date">{{parsedLabels.report}} · {{item._embedded.self[0].custom_date}}</p>
                        <h2 class="report-item__title h3" v-html="item.title"></h2>
                        <a class="report-item__link" :href=item._embedded.self[0].report.url>{{parsedLabels.read_more}}</a>
                    </div>
                </li>
            </ul>
            <p v-if="result.length == 0 && hasSearched">{{ parsedLabels.no_result }}</p>
        </div>
        <paginate v-if="pageCount > 1" :force-page="axiosParams.page" :page-count="pageCount" :page-range="3" :margin-pages="1"
            :click-handler="doPagination" :prev-text="''" :next-text="''" :container-class="'pagination'"
            :page-class="'pagination__item'" :page-link-class="'pagination__item-link'"
            :next-class="'pagination__item pagination__item--next'" :prev-class="'pagination__item pagination__item--prev'"
            :disabled-class="'disabled'"></paginate>
    </div>
</template>

<style lang="scss" scoped>
.search-result {
    max-width: 832px + 2 * $gutter;
    margin: 0 auto;
    padding: 32px $gutter 0;

    &__list-item {
        margin-bottom: 32px;
        border-bottom: 1px solid $grey-200;

        &:last-child {
            margin-bottom: 0;
            border-bottom: none;
        }
    }

    &__result-label {
        padding-bottom: 32px;
    }

    &__loader {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 25vh;
    }
}
</style>
